<template>
  <ExternalQueryList
      endpoint="/api/v2/partnership-activity-mails"
      :headlines="headlines"
      :can-update="() => true"
      :filters="filters"
      @show="(partnershipActivityMail) => $router.push('/companies/'+partnershipActivityMail.attributes.company_id+'/partnership-activity-mails/'+partnershipActivityMail.id)"
  >
    <template v-slot:default="{ row: partnershipActivityMail }">
      <td class="table__ellipsis">
        <router-link :to="'/companies/'+partnershipActivityMail.attributes.company_id+'/partnership-activity-mails/'+partnershipActivityMail.id">
          {{ partnershipActivityMail.attributes.portal_company_name }}
        </router-link>
      </td>

      <td class="table__ellipsis">
        {{ partnershipActivityMail.attributes.portal_name }}
      </td>

      <td class="table__ellipsis">
        {{ partnershipActivityMail.attributes.recipients.length }}
      </td>

      <td class="table__ellipsis">
        {{ partnershipActivityMail.attributes.sent_at | datetime }}
      </td>

      <td class="table__ellipsis">
        {{ partnershipActivityMail.attributes.created_at | datetime }}
      </td>
    </template>

    <template v-slot:list-actions="{ filterValues, canUpdateSelected, load, selected }">
      <li :class="{'disabled': !canUpdateSelected}">
        <a href="#" @click.prevent="sendPartnershipActivityMails(selected ,load)">
          <i class="fa fa-paper-plane"></i> Send
        </a>
      </li>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'
import store from '@/store'
import Permissions from "../../../../mixins/Permissions";
import http from "@/http";
import modal from "@/modal";
import notify from "@/notify";

export default {
  components: {ExternalQueryList},

  mixins: [Permissions],

  props: {
    portals: {
      required: true
    }
  },

  data() {
    return {
      shared: store,

      showingContent: null
    }
  },

  computed: {
    headlines() {
      return [
        {width: 6, text: 'Company'},
        {width: 5, text: 'Portal'},
        {width: 3, text: 'Recipients'},
        {width: 3, text: 'Sent At'},
        {width: 3, text: 'Created At'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'select',
            name: 'portal_id',
            options: this.portals.map(portal => ({value: portal.id, label: portal.attributes.name})),
            nullable: true,
            placeholder: 'Choose Portal...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    showContent(partnershipActivityMail) {
      this.showingContent = partnershipActivityMail

      $('#show-partnership-activity-mail-content-modal').modal('show')
    },

    sendPartnershipActivityMails(selected, load) {
      modal.confirm('Are your sure that you want to send the mails?', () => {
        Promise
            .all(selected.map(partnershipActivityMail => http.post('/api/v2/partnership-activity-mails/' + partnershipActivityMail.id + '/send').catch(() => {
            })))
            .then(() => {
              notify.success('The mails were sent')

              load()
            })
      })
    }
  }
}
</script>
